/**
 * In local dev, if the app is not served from port 8888 (Netlify Dev),
 * use this base so function calls hit the Netlify Dev server.
 * Open the app at http://localhost:8888 for same-origin; or run on 3000 and this redirects functions to 8888.
 */
export function getNetlifyFunctionsBase() {
  if (typeof window === "undefined") return "";
  const { hostname, port } = window.location;
  if (hostname === "localhost" && port !== "8888") return "http://localhost:8888";
  return "";
}
